import Vue from 'vue';
import axios from 'axios';
import Notify from "@/plugins/notify";
import apiPermissions from '../../api/permisos';


export async function singIn(context, user ) {
    try{
        /* context.commit('setLoading', true, { root:true }); */
        let url = 'auth/login';
        await Vue.axios({
            method: "POST",
            url: url,
            data: user
        })
        .then(async (response)=>{
            var data = [];
           /* if(response.status == 202){
                Notify.TimerWeb(
                    "ADVERTENCIA",
                    "Para tener una mejor experiencia de usuario loguearse en el sistema de nómina",
                    10000,
                    () => {
                        let host = window.location.hostname;
                        if (
                            host === "gdth.cliker.com.mx" || 
                            host === "www.gdth.cliker.com.mx"
                        ) {
                            window.location.href = 'https://payroll.cliker.com.mx';
                        } 
                        else if (
                            host === "mid20dev.pbmg.com.mx" ||
                            host === "www.mid20dev.pbmg.com.mx"
                        ) {
                            window.location.href = 'https://payrolldev.pbmg.com.mx';
                        }
                        else if (
                            host === "gdth.dv" ||
                            host === "www.gdth.dv"
                        ) {
                            window.location.href = 'http://nominas.dv';
                        }
                    }
                );
            }*/
            data = {
                user,
                "token"         : response.data.access_token,
                "expires_at"    : response.data.expires_at,
                "datos"         : response.data.user,
                "menu"          : response.data.menu,
                "foto_usr"      : response.data.user.profile_picture,
                "img_logo"      : response.data.user.foto_empresa,
                "sistema"       : response.data.sistema
            };

            //await userPermissions(response.user)
            /** Permisos */
            let arr = response.data.permisos
            //console.log(response)
            let arr2 = []
            
            await arr.map(async val => {
                await val.permisos.map(val2 => {
                    if(val2.checked == true){
                        arr2.push(val2.name)
                    }
                })
            })
            sessionStorage.setItem("permisos", JSON.stringify(arr2))
            /** Fin Permisos */

            if(localStorage.getItem("versionCliker")){
                let version =localStorage.getItem("versionCliker")
                if(version === response.data.version){
                    //Esta actualizado Cliker
                }
                else {
                    //No esta actualizado Cliker
                    localStorage.setItem("versionCliker", response.data.version) 
                    setTimeout(() => {
                        window.location.reload(true);
                    }, 2000);
                }
            }
            else{
                //No hay version en localStorage, se actualiza Cliker para evitar que se tenga versiones antiguas
                localStorage.setItem("versionCliker", response.data.version)
            
                setTimeout(() => {
                    window.location.reload(true);
                }, 2000); 
            }

            context.commit('setUser',data);
            localStorage.setItem("tokenPB", response.data.access_token);
            axios.defaults.headers.common['Authorization'] = 'Bearer '+ response.data.access_token;
        })
    }
    catch(e){
        //console.log(e)
        var message = null;
        message = "Favor de validar los datos."
        context.commit('authError',message);
    }
}

async function userPermissions(user){
    setTimeout(() => {
        let parametros = {
            usuario_id : user.id
        }
        apiPermissions.getAllPermissionsUser(parametros).then(async response => {
            let arr = response.data
            let arr2 = []
            
            await arr.map(async val => {
                await val.permisos.map(val2 => {
                    if(val2.checked == true){
                        arr2.push(val2.name)
                    }
                })
            })

            sessionStorage.setItem("permisos", JSON.stringify(arr2))
        })
        .catch(err => {
            console.log(err)
        })
    }, 500);
}

export async function update_password(context, user ) {
    context.commit('update_password',user);
}

export async function update_cliente(context, data) {
    context.commit('update_cliente',data);
}

export async function updateUserData(context, user) {
    try{
        let url = 'refresh';
        await Vue.axios({
            method: "POST",
            url: url,
            data: user
        })
        .then((response) => {
            var data = [];
            data = {
                user,
                "datos"         : response.data.user,
                "menu"          : response.data.menu,
                "foto_usr"      : response.data.user.profile_picture,
                "sistema"       : response.data.sistema
            };
            context.commit('updateUserData',data);
        })
    }
    catch(e){
        var message = null;
        console.log(e);
        if(e.response.data.error == "Unauthorized"){
            message = "Favor de validar los datos.";
        }else{
            message = e.response.data.error;
        }
        context.commit('authError',message);
    }
}

export async function logout(context, user ) {
    try{
        let url = 'logout';
        await Vue.axios({
            method: "GET",
            url: url,
            data: user
        })
        .then((response)=>{
            context.commit('logout');
        })
    }
    catch(e){
        var message = null;
    }
}

export function notificacion(){
    $(".swal2-container").css('background-color', 'rgba(0, 36, 56,0.95)');//changes the color of the overlay
      $(".swal2-modal").css('background-color', '#FE4A49'); //Optional changes the color of  the sweetalert 
      $("#swal2-title").css('color', '#FFFFFF');
      $(".swal2-confirm").css({'color':'red', 'width': '80%', 'border-radius': '40px', 'background': '#FFFFFF' });
      $(".swal2-icon.swal2-warning").css({'color':'#FFFFFF' , 'border-color': '#FFFFFF'});
      $(".swal2-cancel").css({'color':'#FFFFFF', 'background': '#FE4A49' });
      $(".swal2-content").css({'color':'#FFFFFF'});
      /* $(".swal2-close").css({'color':'#000000', 'background': '#FFFFFF','border-radius': '100px', 'margin': '10px' }); */
      
}

export async function updateFoto(context, foto) {
    context.commit('updateFoto',foto);
}

export async function updateLogo(context, logo) {
    context.commit('updateLogo', logo);
}
